export enum ErrorCodes {
    USER_ALREADY_EXISTS = 'user_exists',
    ACCESS_DENIED = 'access_denied',
    TOO_MANY_ATTEMPTS = 'too_many_attempts',
}
